import React from 'react';

import logo from "../../../assets/logos/logo-full.png"

import './LandingSector.css';

const Inicio = () => {
  return (
    <section className="inicio">
        <div className="inicio-container">
            <div className="texto">
                <p>
                Nuestra misión es brindar soluciones inmobiliarias personalizadas en Dubái, combinando experiencia
                local e internacional para gestionar inversiones de forma integral, creando valor sostenible y
                oportunidades a tu medida.
                </p>
            </div>
            <div className="logo-full">
                <img src={logo} alt="Logo" />
            </div>
        </div>
    </section>
  );
};

export default Inicio;